import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-framework-angular-material',
	templateUrl:'./AngularMaterialFrameworkPage.html',
	styles: [],
	styleUrls:['./AngularMaterialFrameworkPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AngularMaterialFrameworkPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_35 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>angular-material</artifactId>
</dependency>
\`\`\``;
	mdContent_36 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:angular-material:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_37 = `\`\`\`json
"@angular/material": "^19.1.4"
"@angular/animations": "^19.0.1"
\`\`\``;
	mdContent_38 = `\`\`\`java
// Accordion with expansion panels
var accordion = new MatAccordion<>();
var panel = new MatAccordionPanel<>();
panel.getHeader().getTitle().setText("Section 1");
panel.getContent().add(new Paragraph<>().setText("Content"));
accordion.add(panel);

// Button with icon
var button = new MatButton<>();
button.add(new MatIcon<>("home"));
button.setText("Home");
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
